export interface PlaceholderPageProps {
  title: string;
  description: string;
  testId: string;
}

export function PlaceholderPage({ title, description, testId }: PlaceholderPageProps) {
  return (
    <main className="placeholder-page" data-testid={testId}>
      <section className="placeholder-card">
        <p className="eyebrow">Trải nghiệm gọi món</p>
        <h1>{title}</h1>
        <p>{description}</p>
        <div className="placeholder-rule" aria-hidden="true" />
        <small>Giao diện mobile-first đang sẵn sàng cho luồng nghiệp vụ tiếp theo.</small>
      </section>
    </main>
  );
}
